import React from 'react';

import List from './routes/list/list.jsx';
import Load from './routes/load/load.jsx';
import File from './routes/file/file.jsx';

export const routes = [ {
    title: 'List',
    pattern: '/:fileType?',
    render: ( props ) => <List { ...props } />
}, {
    title: 'Load',
    pattern: '/:fileType/load',
    render: ( props ) => <Load { ...props } />
}, {
    title: 'File',
    pattern: '/files/:fileId',
    render: ( props ) => <File { ...props } />
} ];

export const getMiddleware = ( store ) => {
	return [];
};
